import { IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel, Currency } from "config/constants"
import Address, { IAddressDto } from "./Address"

export interface IGetErpCustomerDto {
    customerName: string
    customerNumber: string
    customerBlocked: boolean
    invoiceAddress?: IAddressDto | null
    vatCode?: string | null
    salesPersonNumber?: string | null
    salesRepresentativeERP?: string | null
    termsOfPaymentCode?: string | null
    termsOfDeliveryCode?: string | null
    currency?: Currency | null
    language?: string | null
    links?: IApiLink[]
}

export default class ErpCustomer {
    customerName: string
    customerNumber: string
    customerBlocked: boolean
    invoiceAddress?: Address
    vatCode?: string
    salesPersonNumber?: string
    salesRepresentativeERP?: string
    termsOfPaymentCode?: string
    termsOfDeliveryCode?: string
    currency?: Currency
    language?: string
    linkGetCustomerDocuments?: IApiLink
    linkAddCustomerDocuments?: IApiLink

    constructor(dto: IGetErpCustomerDto) {
        this.customerName = dto.customerName
        this.customerNumber = dto.customerNumber
        this.customerBlocked = dto.customerBlocked
        this.invoiceAddress = dto.invoiceAddress ? new Address(dto.invoiceAddress) : undefined
        this.vatCode = dto.vatCode || undefined
        this.salesPersonNumber = dto.salesPersonNumber || undefined
        this.salesRepresentativeERP = dto.salesRepresentativeERP || undefined
        this.termsOfPaymentCode = dto.termsOfPaymentCode || undefined
        this.termsOfDeliveryCode = dto.termsOfDeliveryCode || undefined
        this.currency = dto.currency || undefined
        this.language = dto.language || undefined
        this.linkGetCustomerDocuments = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.customerDocuments && lnk.rel === ApiLinkRel.all)
        this.linkAddCustomerDocuments = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.customerDocuments && lnk.rel === ApiLinkRel.new)
    }
}
